import type { CommandProps } from '@tiptap/core';

/**
 * Command to insert a node fragment consisting of a merge field node and a text node
 * with a single space as its content. Will apply the current editor or selection marks.
 *
 * ProseMirror docs for the Schema's node create function: Node create docs: https://prosemirror.net/docs/ref/#model.NodeType.create
 */
export const insertMergeField = (
  attrs: { label: string; relationship: string; unescaped?: boolean },
  appendMergeFieldExtraSpace = false
) => {
  return ({ tr, editor: { schema, state } }: CommandProps) => {
    const marks = state.storedMarks || state.selection.$from.marks();
    const mergeField = schema.nodes.mergeField.create(attrs, null, marks);
    const content = appendMergeFieldExtraSpace
      ? [mergeField, schema.text(' ', marks)]
      : [mergeField];
    const { from, to } = tr.selection;
    tr.replaceWith(from, to, content);
    return true;
  };
};
